import Vue from 'vue'

import './styles/quasar.sass'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/Notify.js';import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';import Loading from 'quasar/src/plugins/Loading.js';


Vue.use(Quasar, {
  config: {},
  plugins: {
    Notify,
    Loading
  },
  title: 'Index Page',
  components:{
    QSpinnerHourglass
  }
 })